import styled from 'styled-components';
import { Text } from '@morressier/ts';
import { Checkbox } from 'components/ProfileUIComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const SecondaryText = styled(Text)`
  color: var(--color-mono-40);
`;

export const StyledCheckbox = styled(Checkbox)`
  padding: 1rem;
  background-color: #ffffff;
  border-radius: 4px;
  label:focus-within {
    outline: none;
  }
  &:focus-within {
    outline: var(--focus-style);
    outline-offset: 2px;
  }
`;

export const AllCheckbox = styled(Checkbox)`
  margin-left: 1rem;
  margin-bottom: 2rem;
`;

export const Loader = styled(FontAwesomeIcon)`
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
